Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Fade = Fade;
var _react = _interopRequireWildcard(require("react"));
var _reactNativeReanimated = _interopRequireWildcard(require("react-native-reanimated"));
var _jsxRuntime = require("react/jsx-runtime");
var _jsxFileName = "/vercel/path0/example/src/components/Fade.tsx";
function _getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function _interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != typeof e && "function" != typeof e) return {
        default: e
    };
    var t = _getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n.default = e, t && t.set(e, n), n;
}
var TRANSLATE_OFFSET = 50;
var _worklet_6984590131850_init_data = {
    code: "function anonymous(){const{styleValue,interpolate,TRANSLATE_OFFSET}=this.__closure;return{opacity:styleValue.value,transform:[{translateY:interpolate(styleValue.value,[0,1],[TRANSLATE_OFFSET,0])}]};}",
    location: "/vercel/path0/example/src/components/Fade.tsx",
    sourceMap: '{"version":3,"names":["anonymous","styleValue","interpolate","TRANSLATE_OFFSET","__closure","opacity","value","transform","translateY"],"sources":["/vercel/path0/example/src/components/Fade.tsx"],"mappings":"AAuB0C,SAAAA,UAAA,QAAAC,UAAA,CAAAC,WAAA,CAAAC,gBAAA,OAAAC,SAAA,OAAO,CAC7CC,OAAO,CAAEJ,UAAU,CAACK,KAAK,CACzBC,SAAS,CAAE,CACT,CACEC,UAAU,CAAEN,WAAW,CACrBD,UAAU,CAACK,KAAK,CAChB,CAAC,CAAC,CAAE,CAAC,CAAC,CACN,CAACH,gBAAgB,CAAE,CAAC,CACtB,CACF,CAAC,CAEL,CAAC"}',
    version: "3.5.4"
};
function Fade(_ref) {
    var children = _ref.children, style = _ref.style, _ref$delay = _ref.delay, delay = _ref$delay === void 0 ? 0 : _ref$delay;
    var styleValue = (0, _reactNativeReanimated.useSharedValue)(0);
    var animatedStyles = (0, _reactNativeReanimated.useAnimatedStyle)(function() {
        var _e = [
            new global.Error(),
            -4,
            -27
        ];
        var anonymous = function anonymous() {
            return {
                opacity: styleValue.value,
                transform: [
                    {
                        translateY: (0, _reactNativeReanimated.interpolate)(styleValue.value, [
                            0,
                            1
                        ], [
                            TRANSLATE_OFFSET,
                            0
                        ])
                    }
                ]
            };
        };
        anonymous.__closure = {
            styleValue: styleValue,
            interpolate: _reactNativeReanimated.interpolate,
            TRANSLATE_OFFSET: TRANSLATE_OFFSET
        };
        anonymous.__initData = _worklet_6984590131850_init_data;
        anonymous.__workletHash = 6984590131850;
        anonymous.__stackDetails = _e;
        return anonymous;
    }());
    (0, _react.useEffect)(function() {
        styleValue.value = (0, _reactNativeReanimated.withDelay)(delay, (0, _reactNativeReanimated.withTiming)(1));
    }, [
        delay
    ]);
    return (0, _jsxRuntime.jsx)(_reactNativeReanimated.default.View, {
        style: [
            animatedStyles,
            style
        ],
        children: children
    });
}
